import PropTypes from 'prop-types';
import { attr, fk, Model } from 'redux-orm';

class PatientGuideCmsAlignment extends Model {
  static modelName = 'PatientGuideCmsAlignment';

  static fields = {
    id: attr(),
    assessmentType: attr(),
    tier: attr(),
    assessmentDate: attr(),
    initialPatient: attr(),
    ptReferralSource: attr(),
    reassessmentReason: attr(),
    caregiverStatus: attr(),
    caregiverStatusOs: attr(),
    clinicianAttestation: attr(),
    nursingHomeStatus: attr(),
    eligibleResidenceAttestation: attr(),
    residenceType: attr(),
    rccPartnerId: attr(),
    unEffectiveDate: attr(),
    unalignmentReason: attr(),
    clinicianFirstName: attr(),
    clinicianMiddleName: attr(),
    clinicianLastName: attr(),
    npi: attr(),
    documentId: attr(),
    createdAt: attr(),
    updatedAt: attr(),
    updatedBy: fk('Client', 'cmsAlignmentChanger'),
    createdBy: fk('Client', 'cmsAlignmentCreator'),
    patientId: fk({
      to: 'Patient',
      as: 'patient',
      relatedName: 'cmsAlignments',
    }),
  };

  static schema = {
    _fields: PropTypes.exact({
      id: PropTypes.string,
      assessmentType: PropTypes.string,
      tier: PropTypes.string,
      assessmentDate: PropTypes.string,
      initialPatient: PropTypes.bool,
      ptReferralSource: PropTypes.string,
      reassessmentReason: PropTypes.string,
      caregiverStatus: PropTypes.string,
      caregiverStatusOs: PropTypes.string,
      clinicianAttestation: PropTypes.string,
      nursingHomeStatus: PropTypes.string,
      eligibleResidenceAttestation: PropTypes.string,
      residenceType: PropTypes.string,
      rccPartnerId: PropTypes.string,
      unEffectiveDate: PropTypes.string,
      unalignmentReason: PropTypes.string,
      clinicianFirstName: PropTypes.string,
      clinicianMiddleName: PropTypes.string,
      clinicianLastName: PropTypes.string,
      npi: PropTypes.string,
      documentId: PropTypes.string,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string,
      updatedBy: PropTypes.number,
      createdBy: PropTypes.number,
      patientId: PropTypes.number,
    }),
    patientId: PropTypes.number,
  };
}

export default PatientGuideCmsAlignment;
